import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useAppDispatch } from 'hooks/reduxHooks'

import Leaderboard from 'components/Common/Banner/Leaderboard'
import { fetchBanners } from 'actions/ContentActions'
import { getPlacement } from 'lib/url/campaignUtils'
import { BANNER_LOCATION_HUB } from 'constants/bannerLocations'
import { EmptyArray } from 'lib/array/arrayUtils'

interface Props extends App.HubPageComponentBannersLoader {
  banners?: Array<App.Banner>;
}

function BannersLoader({ banners = EmptyArray, tags }: Props) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchBanners(BANNER_LOCATION_HUB, tags))
  }, [dispatch, tags])

  const topBanners = getPlacement(banners, 'top')

  if (!topBanners.length) {
    return null
  }

  return <Leaderboard banners={topBanners} />
}

function mapStateToProps(state: App.State) {
  return {
    banners: state.content.banners.hub,
  }
}

export default connect(mapStateToProps)(BannersLoader)
